var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"view",staticClass:"goods-vip-forever"},_vm._l((_vm.defaultList),function(item,index){return _c('div',{key:index},[_c('van-image',{attrs:{"fit":"contain","lazy-load":"","src":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }